import store from '@/store/store';
import { getSheetsConfig, saveSheetsConfig } from '@/febos/servicios/api/dnt.api';
import { listOptions } from '@/febos/servicios/api/opciones.api';
import { ioExtraDataListar, ioExtraDataGuardar } from '@/febos/servicios/api/herramientas.api';
import { ioCompanyGetAccessProfiles } from '@/febos/servicios/api/v2.companies.api';

export default {
  async getWorkerData({ commit }, query) {
    /* Hago la primera petición y cuando hay resultado,
    creo los filtros que crea la linea filtros.join()
    para hacer la segunda peticion que me traera las funciones.
    Ya que no vienen en la misma peticion.
    */
    let data = null;
    const response = await ioExtraDataListar(query);
    data = response.data.valores;
    if (parseInt(data.FUNCIONESN?.valor, 10) > 0) {
      // Permite crear un array en base a un int, con un length especificado
      const arrFunciones = Array.from(Array(parseInt(data.FUNCIONESN.valor, 10)).keys());
      const filtros = arrFunciones.map((n) => `FUNCIONESN-${n}`);
      // eslint-disable-next-line
      query.filtros = `nombre:${filtros.join()}`;
      const funciones = await ioExtraDataListar(query);
      data.FUNCIONES = funciones.data.valores;
    }
    commit('SET_WORKER_DATA', data);
  },
  async setWorkerData(_, payload) {
    const resp = await ioExtraDataGuardar(payload);
    return resp;
  },
  async fetchAllDocuments({ commit }) {
    const response = await listOptions({
      grupoOpcion: 'tipos.documentos-ed',
      deshabilitado: 'no',
      agrupar: 'si'
    });

    commit('SET_ALL_DOCUMENTS', response.data.opciones);
  },
  async getDocConfigSheet({ commit }, payload) {
    try {
      commit('SET_CONFIG_SHEET', []);
      store.commit('Empresas/SET_LOADING', true);
      const response = await getSheetsConfig(payload);
      commit('SET_CONFIG_SHEET', response.data);
      return response;
    } finally {
      store.commit('Empresas/SET_LOADING', false);
    }
  },
  async saveDocConfigSheet({ commit }, config) {
    commit('SET_CONFIG_SHEET', []);
    const response = await saveSheetsConfig({ id: config.referenciaId }, config);
    commit('SET_SUCCESS_MESSAGE', response.data);
    commit('SET_CONFIG_SHEET', response.data);
    return response;
  },
  updateConfig({ commit }, configDoc) {
    commit('UPDATE_CONFIG_DOC', configDoc);
  },
  async getCompanyAccessProfiles({ commit }, payload) {
    try {
      commit('SET_COMPANY_PROFILES', []);
      store.commit('Empresas/SET_LOADING', true);
      const response = await ioCompanyGetAccessProfiles(payload);
      commit('SET_COMPANY_PROFILES', response.data);
      return response;
    } finally {
      store.commit('Empresas/SET_LOADING', false);
    }
  },
};
